export const MERCHANT = {
    GET_MERCHANT_DETAIL: 'merchant/GET_MERCHANT_DETAIL', 


};